import styled from 'styled-components';

export const ContainerHeader = styled.header`
    background: var(--background-header);
    ul {
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding: 1.1rem;
        li {
            list-style: none;
            display: flex;
            flex-direction: row;
            span {
                margin-left: 0.5rem;
                color: var(--aqua);
                font-weight: 700;
            }
        }
        li + li {
            margin-left: 4rem;
        }
    }
    svg {
        color: var(--aqua);
        font-size: 24px;
        vertical-align: middle;
    }

    @media(min-width: 550px) {
        ul {
            margin-top: 0rem;
        }
    }

    @media only screen and (max-width: 540px) {
        ul {
            li + li {
                margin-left: 2rem
            }
        }
    }
    @media(max-width: 425px) {
        ul {
            margin-top: 0rem;
        }
        svg {
            font-size: 18px;
        }
    }

    @media(max-width: 320px) {
        ul {
            padding: 0.10000000000000009rem;
            margin-top: 1rem;
        }
    }
`

export const Content = styled.div`
    z-index: 1;
    position: fixed;
    background: white;
    max-width: 100vw;
    width: 100vw;
    box-sizing: border-box;
    margin: 0 auto;
    height: 3.5rem;
`